<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Devices</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Devices</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header py-3" v-if="is_loading == false">
            <div class="btn-toolbar pull-right">
              <!-- <el-dropdown split-button :trigger="'click'" @command="handleSelectedRows" type="primary"
                v-if="this.selected_row.length" class="mr-1">
                {{ this.selected_row.length }} {{ 'item' | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete">Delete Selected Items</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <button
                v-if="this.selected_row.length"
                class="btn btn-outline mr-3"
                @click="showModal = !showModal"
                data-toggle="modal"
                data-target="#modalPopup"
              >
                {{ this.selected_row.length }}
                {{ "items" | pluralize(this.selected_row.length) }} selected
                <i class="icon-clipboard"></i>
              </button>

              <div
                v-if="showModal"
                id="modalPopup"
                class="modal fade"
                tabindex="-1"
                role="dialog"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-body">
                      <div class="form-group">
                        <label class="control-label">Assign To Group</label>
                        <multiselect
                          v-model="actionStatus"
                          :options="pre.groupNames"
                          :searchable="false"
                          :multiple="false"
                          id="actionStatus"
                          v-bind:class="{
                            'has-error': errors.has('actionStatus'),
                          }"
                          v-validate="'required'"
                          name="actionStatus"
                        >
                        </multiselect>
                      </div>

                      <!-- <div class="form-group">
                        <label class="control-label">Macbinding</label> <br />
                        <div class="d-flex align-items-center">
                          <label class="radio mr-3">
                            <input
                              type="radio"
                              id="isMacbinding"
                              name="isMacbinding"
                              v-model="isMacbinding"
                              class="isMacbinding"
                              value="1"
                            /><span class="radio-mark"></span> Yes
                          </label>
                          <label class="radio"
                            ><input
                              type="radio"
                              id="isMacbinding"
                              name="isMacbinding"
                              v-model="isMacbinding"
                              class="isMacbinding"
                              value="0"
                            /><span class="radio-mark"></span> No
                          </label>
                        </div>
                      </div> -->
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline"
                        data-dismiss="modal"
                        @click="showModal = !showModal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        @click="handleSelectedRows"
                        data-dismiss="modal"
                        class="btn"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-sm-inline-flex">Filter</span>
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Audra Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="(opt) => pre.audraName[opt]"
                          placeholder="Select Audra Name"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId'),
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Device MAC -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Device_MAC"
                      >DEVICE MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="Device_MAC"
                          name="Device_MAC"
                          v-model="filter.Device_MAC"
                          :class="{
                            'has-error': errors.has('Device_MAC'),
                          }"
                          class="form-control"
                          placeholder="Device MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- IP Address -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="ip_address">IP</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="ip_address"
                          name="ip_address"
                          v-model="filter.ip_address"
                          :class="{
                            'has-error': errors.has('ip_address'),
                          }"
                          class="form-control"
                          placeholder="IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Device Name -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Device Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.Name"
                          :options="pre.deviceNames"
                          placeholder="Select Device Name"
                          :searchable="true"
                          :multiple="false"
                          id="Name"
                          v-bind:class="{
                            'has-error': errors.has('Name'),
                          }"
                          name="Name"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Group Name -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Group Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.group_name"
                          :options="pre.groupNames"
                          placeholder="Select Group Name"
                          :searchable="true"
                          :multiple="false"
                          id="group_name"
                          v-bind:class="{
                            'has-error': errors.has('group_name'),
                          }"
                          name="group_name"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Status -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="status">Status</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.status"
                          :options="pre.status"
                          placeholder="Select Status"
                          :searchable="true"
                          :multiple="false"
                          id="status"
                          v-bind:class="{ 'has-error': errors.has('status') }"
                          name="status"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6>Total Item: {{ list.total }}</h6>
              </div>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 24px">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="is_selected_all"
                            @click="selectedRowAll()" />
                          <span class="checkmark"></span
                        ></label>
                      </th>
                      <th v-if="organizationId == 1">Audra</th>
                      <th>Name</th>
                      <th>Mac</th>
                      <th>IP</th>
                      <th>Group</th>
                      <!-- <th>Usage Today</th> -->
                      <th>Status</th>

                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>
                        <label class="checkbox">
                          <input type="checkbox" v-model="selected_row" :value="val.id" />
                          <span class="checkmark"></span
                        ></label>
                      </td>
                      <td v-if="organizationId == 1">
                        {{ val.device_name }}
                      </td>

                      <td>{{ val.Name }}</td>

                      <td>
                        <router-link
                          :to="{
                            name: 'addDeviceRule',
                            params: {
                              id: val.id,
                              group_name: val.group_name,
                              Device_MAC: val.Device_MAC,
                              accountId: val.accountId,
                              ip_address: val.ip_address,
                            },
                          }"
                          class="link-cell"
                          >{{ val.Device_MAC }}
                          <i class="icon-arrow-right"></i>
                        </router-link>
                      </td>
                      <td>{{ val.ip_address }}</td>
                      <td>{{ val.group_name }}</td>
                      <!-- <td>
                        {{
                          val.total_usage
                            ? val.total_usage / 1024 < 1024
                              ? (val.total_usage / 1024).toFixed(2) + " KB"
                              : val.total_usage / 1024 / 1024 < 1024
                              ? (val.total_usage / 1024 / 1024).toFixed(2) +
                                " MB"
                              : val.total_usage / 1024 / 1024 / 1024 > 0
                              ? (val.total_usage / 1024 / 1024 / 1024).toFixed(
                                  2
                                ) + " GB"
                              : val.total_usage + " BYTE"
                            : "0 BYTE"
                        }}
                      </td> -->
                      <td>{{ val.status }}</td>
                      <td class="text-right">
                        <div class="d-flex justify-content-end align-items-center">
                          <router-link
                            class="btn btn-edit mr-2"
                            v-if="actionEdit == true"
                            :to="{
                              name: 'DeviceEdit',
                              params: { id: val.id },
                            }"
                          >
                            <i class="icon-edit"></i>
                          </router-link>
                          <div
                            class="d-flex"
                            v-if="val.blocked == 0"
                            href="javascript:void(0)"
                            @click="
                              deviceBlockUnblock(
                                val.id,
                                val.accountId,
                                val.Device_MAC,
                                val.status,
                                val.blocked
                              )
                            "
                          >
                            <div
                              data-toggle="tooltip"
                              data-placement="left"
                              title="Turn off internet"
                              class="internet-switch active ml-auto"
                            >
                              ON <i class="icon-globe"></i>
                            </div>
                          </div>
                          <div
                            class="d-flex"
                            v-else
                            href="javascript:void(0)"
                            @click="
                              deviceBlockUnblock(
                                val.id,
                                val.accountId,
                                val.Device_MAC,
                                val.status,
                                val.blocked
                              )
                            "
                          >
                            <div title="Turn on internet" class="internet-switch ml-auto">
                              <i class="icon-globe"></i> OFF
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style>
.modal {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  z-index: 99999;
}
</style>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
const fileDownload = require("js-file-download");

export default {
  name: "Device",
  metaInfo: {
    title: "Devices | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: true,
    actionDelete: false,
    actionBlockUnblock: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: {},
      groupNames: [],
      deviceNames: [],
      status: ["ACTIVE", "INACTIVE"],
    },
    actionStatus: "",
    isMacbinding: "0",
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    showModal: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/devices";
    this.filter = this.$route.params;

    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      const _this = this;
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/devices"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getGroupNames()
        .then((response) => {
          this.pre.groupNames = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getDeviceNames()
        .then((response) => {
          this.pre.deviceNames = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, index) {
      const _this = this;
      const delete_api_url = "/devices/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url)
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },

    getGroupNames: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-group-names", {
            params: {
              accountId: LocalStorage.get("accountId"),
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getDeviceNames: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-filter-device-names", {
            params: {
              accountId: LocalStorage.get("accountId"),
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push(item.id);
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },

    handleSelectedRows() {
      const _this = this;
      axios({
        method: "put",
        url: "/devices-bulk-action",
        data: {
          ids: this.selected_row,
          actionStatus: this.actionStatus,
          isMacbinding: this.isMacbinding,
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          Notification.success({
            title: "Updated Successfully",
            message: "Data updated successfully",
            type: "success",
          });
        })
        .catch((errors) => {
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          this.showModal = false;
          this.is_selected_all = false;
          this.initialize();
        });
    },

    deviceBlockUnblock: function (id, accountId, Device_MAC, status, blocked) {
      const _this = this;
      const apiUrl = "/deviceBlockUnblock";
      _this.is_loading = true;

      const newBlockedValue = !blocked;

      axios
        .post(apiUrl, {
          id: id,
          accountId: accountId,
          Device_MAC: Device_MAC,
          status: status,
          action: newBlockedValue ? 1 : 0,
        })
        .then((response) => {
          _this.$toaster.success(response.data.message);
          const deviceIndex = _this.list.data.findIndex((device) => device.id === id);
          if (deviceIndex !== -1) {
            _this.$set(_this.list.data, deviceIndex, {
              ..._this.list.data[deviceIndex],
              blocked: newBlockedValue,
            });
          }
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.errors.message);
            _this.$setErrorsFromResponse(errors.response.data.errors);
          } else if (errors.response.data) {
            _this.$toaster.error(errors.response.data.message);
            _this.$setErrorsFromResponse(errors.response.data);
          }
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>

<style scoped>
.link-cell {
  cursor: pointer;
  color: #00a79c;
  text-decoration: underline;
  font-weight: bold;
}
</style>
